import {
  BrowseViewResponseDto,
  ApiError,
  ErrorResponseDto,
  BrowseViewState,
} from '@pro4-erp/core-web';
import { AuditorCompetence } from '@/common';
import env from '@/env';

export const getAuditorCompetencesForMe = async ({
  page,
  pageSize,
  search,
  sortBy,
}: BrowseViewState): Promise<BrowseViewResponseDto<AuditorCompetence>> => {
  const fetchResponse = await fetch(
    `${env.VITE_API_URL}/pb/s/api/sqo-portal/auditor-comps/me?${new URLSearchParams({
      page: page.toString(),
      pageSize: pageSize.toString(),
      search: search.toString(),
      sortBy: sortBy ? JSON.stringify(sortBy) : '',
    })}`,
    {
      method: 'GET',
      headers: {
        authenticate: localStorage.getItem('accessToken') || '',
      },
    }
  );

  if (!fetchResponse.ok) {
    const error = (await fetchResponse.json()) as ErrorResponseDto;
    throw new ApiError(error);
  }

  const response = (await fetchResponse.json()) as BrowseViewResponseDto<AuditorCompetence>;
  return response;
};
